import { PageLoader } from '@/components/atoms';

export const LoadingState = () => (
  <PageLoader fullPage message="Loading conversations..." />
);
